var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container module"},[(!!_vm.banner)?_c('PageHeader',{attrs:{"height":1080,"type":"image","image":_vm.banner}}):_vm._e(),_c('div',{staticClass:"sction pagenav"},[_c('PageNav')],1),_c('router-view'),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }